<template>
  <div
    class="billing-line-item-cell"
    :class="{ 'billing-line-item-cell-emphasized': emphasized }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BillingLineItemCell',
  props: {
    emphasized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.billing-line-item-cell-emphasized {
  font-weight: 500;
}
.billing-line-item-cell {
  padding: 0.625rem;
  border-bottom: dotted 1px #d3d3d3;
  text-align: right;
}
</style>
